export default "__VITE_ASSET__k5qu3yMp__"